import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../../environments/environment';
import {
  BalanceSnapshotLatest,
  BalanceSnapshotRun,
  BalanceSnapshotRunSearchCommand,
  BalanceSnapshotRunSearchResult,
  ComputeBalanceSnapshotCommand,
} from '../../models/balance-snapshot-run/balance-snapshot-run';

/**
 * Balance snapshot runs of the selected site (X-Site-Id). Reads allow InventoryBalanceAdmin or InventoryBalanceViewer (the
 * API leaves out user names and error details for a viewer); compute requires InventoryBalanceAdmin.
 */
@Injectable({
  providedIn: 'root',
})
export class BalanceSnapshotRunProxyService {
  private readonly http = inject(HttpClient);
  private readonly runUrl = environment.proxyUrls.inventoryApi + '/api/v1/balance-snapshot-run';
  private readonly balanceUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-balance';

  public search(
    command: BalanceSnapshotRunSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string | null,
    sortOrder = -1,
  ): Observable<ApiResponse<BalanceSnapshotRunSearchResult>> {
    let url = `${this.runUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }
    return this.http.post<ApiResponse<BalanceSnapshotRunSearchResult>>(url, command);
  }

  public getLatestBySite(): Observable<ApiResponse<BalanceSnapshotLatest[]>> {
    return this.http.get<ApiResponse<BalanceSnapshotLatest[]>>(`${this.runUrl}/latest-by-site`);
  }

  /** Queues the compute of one month for the selected site (X-Site-Id); the API answers 202 with the new run. */
  public compute(command: ComputeBalanceSnapshotCommand): Observable<ApiResponse<BalanceSnapshotRun>> {
    return this.http.post<ApiResponse<BalanceSnapshotRun>>(`${this.balanceUrl}/snapshot/compute`, command);
  }
}
